import actions from './actions'
import mutations from './mutations'

const payoutLog = {
    namespaced: true,
    state: {
        payoutLogs: [],
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        isLoaded: true
    },
    mutations,
    actions
}

export default payoutLog
